import { createMuiTheme, PaletteColorOptions } from '@material-ui/core/styles';
import { PaletteOptions } from '@material-ui/core/styles/createPalette';

const palette: PaletteOptions & {brand: PaletteColorOptions} = {
    brand: {
        main: '#70a002',
    },
    primary: {
        main: '#557b11',
        contrastText: '#ffffff',
    },
    secondary: {
        main: '#5B8200',
        contrastText: '#ffffff',
    },
    background: {
        default: '#EEEEEE',
    },
    error: {
        main: 'rgb(211, 47, 47)',
    },
    warning: {
        main: 'rgb(245, 124, 0)',
    },
    info: {
        main: '#007ac2',
    },
    success: {
        main: '#308735',
    },
};

export const pageWidth = 680;

export default createMuiTheme({
    palette,
    typography: {
        useNextVariants: true,
    },
});
